export async function copyData(data: string) {
  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(data);
    } else {
      throw Error("");
    }
  } catch {
    const textarea = document.createElement("textarea");
    textarea.value = data;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body?.removeChild(textarea);
  }
}
